/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Fragment as _, useCallback, useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { colors, getButtonFocus, values } from 'styles/variables';
import { HeaderLayout } from 'components/Header_v2/HeaderLayout';

const { lPink, lGrey0 } = colors;
const { headerHeight } = values;

interface IHeader {
  currentTopicIndex: number;
  topics: any[];
  theme: any;
}

const SkipToContent = () => {
  const [skipToContent, setSkipToContent] = useState(false);

  const a = useRef<HTMLAnchorElement>(null);

  return (
    <a
      ref={a}
      css={css`
        position: absolute;
        left: 30px;
        top: 80px;
        padding: 5px 25px;
        font-size: 12px;
        color: ${lGrey0};

        border-radius: 9999px;
        background: #fff;

        text-decoration: none;

        ${!skipToContent &&
        `border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    `}
      `}
      href={`#main`}
      onKeyUp={(e) => {
        if (![' ', 'Enter'].includes(e.key)) {
          return;
        }

        a.current!.click();
      }}
      onFocus={() => {
        setSkipToContent(true);
      }}
      onBlur={() => {
        setSkipToContent(false);
      }}
    >
      Skip to content
    </a>
  );
};

const Background = (props) => {
  const {
    headerHeight = 70,
    background = '#fff',
    opacity = 100,
    headerDropShadow = true,
  } = props;

  return (
    <div
      css={css({
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: headerHeight,
        background,
        opacity: opacity * 0.01,

        zIndex: 0,

        '@media (max-width: 480px)': {
          height: headerHeight - 20,
        },

        ...(headerDropShadow && {
          ':after': {
            content: `""`,
            display: 'block',
            position: 'absolute',
            left: 0,
            top: headerHeight - 10,
            width: '100%',
            height: 10,
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            clipPath: `polygon(0% 10px, 100% 10px, 100% 20px, 0% 20px)`,

            '@media (max-width: 480px)': {
              top: headerHeight - 30,
            },
          },
        }),
      })}
    />
  );
};

export const Burger = (props) => {
  const width = 20;
  // || 24;
  const { color = '#2a2c2d', onClick } = props;

  const [hovered, setHovered] = useState(false);

  return (
    <div
      css={css({
        outline: 'none',
        border: 'none',
        background: 'transparent',
        ':focus': {
          boxShadow: getButtonFocus(color).replace('box-shadow: ', ''),
        },

        // '*': {
        //   pointerEvents: 'none',
        // },
      })}
      onClick={onClick}
      // onMouseOver={e => {
      //   console.log(e);

      //   setHovered(h => !h);
      // }}
    >
      <div
        className="fader_-5s"
        css={css({
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          width,
          height: 17,
          cursor: 'pointer',

          ':hover': {
            'div:nth-of-type(2)': {
              width: '16px !important',
              transition: 'all 0.2s',
            },
          },
        })}
      >
        {[0, 1, 2].map((i) => (
          <div
            key={`burger-${i}`}
            style={{ width, height: 2, background: color, borderRadius: 99999 }}
          />
        ))}
      </div>
    </div>
  );
};

const Header = (props) => {
  const { currentTopicIndex = 0, topics, headerProps } = props;

  const [menu, setMenuState] = useState(false);
  const currentTopicName = topics[currentTopicIndex]
    ? topics[currentTopicIndex].props.name
    : 'unknown';

  let {
    headerBackgroundColor = '#fff',
    headerBackgroundOpacity = 100,
    headerTextColor = lGrey0,
    headerDropShadow = true,
    backButton = true,
    topicName = true,
    progressBar = true,
    topicMenu = true,
    includeLogo = true,
    headerLogo,
  } = headerProps;

  const hideMenu = useCallback(() => {
    setMenuState(false);
    requestAnimationFrame(() =>
      document.removeEventListener('click', hideMenu)
    );
  }, []);

  useEffect(() => {
    // if (!menu) {
    //   return;
    // }
    menu &&
      requestAnimationFrame(() => document.addEventListener('click', hideMenu));
  }, [menu]);

  return (
    <HeaderLayout
      height={70}
      responsiveHeight={50}
      backButton={backButton}
      currentTopicIndex={currentTopicIndex}
      topics={topics}
      headerTextColor={headerTextColor}
      topicName={topicName}
      currentTopicName={currentTopicName}
      includeLogo={includeLogo}
      headerLogo={headerLogo}
      progressBar={progressBar}
      topicMenu={topicMenu}
      menu={menu}
      setMenuState={setMenuState}
      background={
        <Background
          headerHeight={headerHeight}
          background={headerBackgroundColor}
          opacity={headerBackgroundOpacity}
          headerDropShadow={headerDropShadow}
        />
      }
      Burger={Burger}
    />
  );
};

export default connect(({ theme }: any) => ({ theme }))(Header);
